module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "latestreleases"
    }
  }, _vm._l((_vm.releases), function(release, key, index) {
    return _c('div', [_c('release-block', {
      attrs: {
        "release": release,
        "index": index
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ec7ac20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/LatestReleases.vue
// module id = 141
// module chunks = 0